<!--
 * @Author: liushumin
 * @Date: 2022-05-28 00:04:32
 * @LastEditTime: 2023-04-11 20:01:37
 * @LastEditors: liushumin
-->

<template>
  <div class="map-right-info">
    <div class="map-right-info-content">
      <!-- 设备、土壤、环境、长势、视频监测信息 -->
      <div class="map-device-detail">
        <div class="device-info">
          <p>
            <span class="deviceName">{{ this.deviceName }}</span>
          </p>
          <p class="device-info-text">
            <!-- <span v-if="deviceTypeId != 40"> -->
            <span>
              <span class="equip-right-text" v-if="deviceStatus == '设备正常'"
                ><img
                  src="@/assets/agricultural/nqfont/equipRight.png"
                />设备正常</span
              ><span
                class="equip-error-text"
                v-else-if="deviceStatus == '未查询到设备'"
                ><img
                  src="@/assets/agricultural/nqfont/equipError.png"
                />未查询到设备</span
              >
              <span
                class="equip-right-text"
                v-else-if="deviceStatus == '长势正在拍照中'"
                >长势正在拍照中</span
              >
              <span
                class="equip-right-text"
                v-else-if="deviceStatus == '夜间监测休眠'"
                >夜间监测休眠</span
              >
              <span
                class="equip-right-text"
                v-else-if="deviceStatus == '设备加载中'"
                >设备加载中</span
              >
              <span
                class="equip-error-text"
                v-else-if="deviceStatus == '设备不在线'"
                >设备不在线</span
              >
              <span class="equip-error-text" v-else
                ><img
                  src="@/assets/agricultural/nqfont/equipError.png"
                />设备异常</span
              >
            </span>
          </p>
          <p class="device-info-text">
            <span>设备序列号：</span><span>{{ this.deviceCode }}</span>
          </p>
          <p class="device-info-text">
            <span>设备类型：</span><span>{{ this.deviceTypeName }}</span>
            <span
              class="yzd"
              @click="
                $router.push({
                  path: '/Agricultural/AgriculturalMonitoring/Preset',
                  query: { code: deviceCode },
                })
              "
              v-show="deviceTypeName == '长势监测'"
              ><i class="el-icon-time"></i> 拍摄点</span
            >
          </p>
        </div>
        <div
          class="soil-info public-info"
          v-show="deviceTypeId == 20 && edition == 4"
        >
          <p class="soil-info-tit public-info-tit">
            <span><strong class="line"></strong>土壤监测</span
            ><span @click="checkHistory(1)">历史数据></span>
          </p>
          <ul>
            <li>
              <img src="@/assets/agricultural/nqfont/soil_icon1.png" alt="" />
              <p>
                <span>土壤温度</span>
                <span>{{
                  soilV4temData && soilV4temData != null
                    ? soilV4temData + "℃"
                    : "—"
                }}</span>
              </p>
            </li>
            <li>
              <img src="@/assets/agricultural/nqfont/soil_icon2.png" alt="" />
              <p>
                <span>土壤湿度</span>
                <span>{{
                  soilV4humData && soilV4humData != null
                    ? soilV4humData + "%RH"
                    : "—"
                }}</span>
              </p>
            </li>
            <li>
              <img src="@/assets/agricultural/nqfont/soil_icon3.png" alt="" />
              <p>
                <span>电导率</span>
                <span>{{
                  soilV4ConData && soilV4ConData != null
                    ? soilV4ConData + "μS/cm"
                    : "—"
                }}</span>
              </p>
            </li>
            <li>
              <img src="@/assets/agricultural/nqfont/soil_icon4.png" alt="" />
              <p>
                <span>土壤盐分</span>
                <span>{{
                  soilV4SaltData && soilV4SaltData != null
                    ? soilV4SaltData + "μS/cm"
                    : "—"
                }}</span>
              </p>
            </li>
          </ul>
        </div>
        <div
          class="soil-info public-info"
          v-show="deviceTypeId == 20 && edition != 4"
        >
          <p class="soil-info-tit public-info-tit">
            <span><strong class="line"></strong>土壤监测</span
            ><span @click="checkHistory(1)">历史数据></span>
          </p>
          <ul v-if="soilData">
            <li>
              <img src="@/assets/agricultural/nqfont/soil_icon1.png" alt="" />
              <p>
                <span>土壤温度</span>
                <span>{{
                  soilData.wirelessTempData && soilData.wirelessTempData != null
                    ? soilData.wirelessTempData + "℃"
                    : "—"
                }}</span>
              </p>
            </li>
            <li>
              <img src="@/assets/agricultural/nqfont/soil_icon2.png" alt="" />
              <p>
                <span>土壤湿度</span>
                <span>{{
                  soilData.wirelessHumidityData &&
                  soilData.wirelessHumidityData != null
                    ? soilData.wirelessHumidityData + "%RH"
                    : "—"
                }}</span>
              </p>
            </li>
            <li>
              <img src="@/assets/agricultural/nqfont/soil_icon3.png" alt="" />
              <p>
                <span>电导率</span>
                <span>{{
                  soilData.wirelessConductivityData &&
                  soilData.wirelessConductivityData != null
                    ? soilData.wirelessConductivityData + "μS/cm"
                    : "—"
                }}</span>
              </p>
            </li>
            <li>
              <img src="@/assets/agricultural/nqfont/soil_icon4.png" alt="" />
              <p>
                <span>土壤盐分</span>
                <span>{{
                  soilData.wirelessSalinityData &&
                  soilData.wirelessSalinityData != null
                    ? soilData.wirelessSalinityData + "μS/cm"
                    : "—"
                }}</span>
              </p>
            </li>
          </ul>
        </div>
        <div
          class="env-info public-info"
          v-show="deviceTypeId == 10 && edition == 3"
        >
          <p class="env-info-tit public-info-tit">
            <span><strong class="line"></strong>环境监测</span
            ><span @click="checkHistory(2)">历史数据></span>
          </p>
          <ul v-if="EnvData">
            <li>
              <img src="@/assets/agricultural/nqfont/env_icon1.png" alt="" />
              <span>空气温度</span>
              <label>{{ EnvData.temperature }}</label>
            </li>
            <li>
              <img src="@/assets/agricultural/nqfont/env_icon2.png" alt="" />
              <span>空气湿度</span>
              <label>{{ EnvData.humidity }}</label>
            </li>
            <li>
              <img src="@/assets/agricultural/nqfont/env_icon3.png" alt="" />
              <span>大气压力</span>
              <label>{{ EnvData.pressure }}</label>
            </li>
            <li>
              <img src="@/assets/agricultural/nqfont/env_icon4.png" alt="" />
              <span>风速</span>
              <label>{{ EnvData.windSpeed }}</label>
            </li>
            <li>
              <img src="@/assets/agricultural/nqfont/env_icon5.png" alt="" />
              <span>风向</span>
              <label>{{ EnvData.windDirection }}</label>
            </li>
            <li>
              <img src="@/assets/agricultural/nqfont/env_icon6.png" alt="" />
              <span>光照强度</span>
              <label>{{ EnvData.light }}</label>
            </li>
          </ul>
        </div>
        <div
          class="env-info public-info"
          v-show="deviceTypeId == 10 && edition == 4"
        >
          <p class="env-info-tit public-info-tit">
            <span><strong class="line"></strong>环境监测</span
            ><span @click="checkHistory(2)">历史数据></span>
          </p>
          <ul>
            <li>
              <img src="@/assets/agricultural/nqfont/env_icon1.png" alt="" />
              <span>空气温度</span>
              <label>{{
                envV4Temperature && envV4Temperature != null
                  ? envV4Temperature + "℃"
                  : "—"
              }}</label>
            </li>
            <li>
              <img src="@/assets/agricultural/nqfont/env_icon2.png" alt="" />
              <span>空气湿度</span>
              <label>{{
                envV4Humidity && envV4Humidity != null
                  ? envV4Humidity + "%"
                  : "—"
              }}</label>
            </li>
            <li>
              <img src="@/assets/agricultural/nqfont/env_icon3.png" alt="" />
              <span>大气压力</span>
              <label>{{
                envV4Pressure && envV4Pressure != null
                  ? envV4Pressure + "kpa"
                  : "—"
              }}</label>
            </li>
            <li>
              <img src="@/assets/agricultural/nqfont/env_icon4.png" alt="" />
              <span>风速</span>
              <label>{{
                envV4WindSpeed && envV4WindSpeed != null
                  ? envV4WindSpeed + "km/h"
                  : "—"
              }}</label>
            </li>
            <li>
              <img src="@/assets/agricultural/nqfont/env_icon5.png" alt="" />
              <span>风向</span>
              <label>{{
                envV4WindDirection && envV4WindDirection != null
                  ? envV4WindDirection + "风"
                  : "—"
              }}</label>
            </li>
            <li>
              <img src="@/assets/agricultural/nqfont/env_icon6.png" alt="" />
              <span>光照强度</span>
              <label>{{
                envV4Light && envV4Light != null ? envV4Light + "lux" : "—"
              }}</label>
            </li>
          </ul>
        </div>
        <div class="grow-info public-info" v-show="deviceTypeId == 30">
          <p class="grow-info-tit public-info-tit">
            <span><strong class="line"></strong>长势监测</span
            ><span @click="checkHistory(3)">历史数据></span>
          </p>
          <!-- <div class="swiper-container gallery-top" v-if="showSwiper"> -->
          <div class="scroll-container" style="width: 280px" v-if="showSwiper">
            <div class="demo-image__lazy">
              <div class="imgItem" v-for="item in urls" :key="item.id">
                <el-image :src="item.imgeUrl" :preview-src-list="srcList">
                </el-image>
                <p class="absPre">
                  {{ timestampToTime(item.updateTime) }}
                </p>
              </div>
            </div>

            <!-- </div> -->

            <!-- <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                style="background: #ccc"
                v-for="(item, index) in swiperList"
                :key="index"
              >
                <img :src="item.imgeUrl" alt="" />
                <p class="posBack">
                  {{ item.uptTime | moment("YYYY-MM-DD ") }}
                </p>
              </div>
            </div> -->
            <!-- <div
              class="swiper-button-next swiper-button-white"
              tabindex="0"
              role="button"
            ></div>
            <div
              class="swiper-button-prev swiper-button-white"
              tabindex="0"
              role="button"
            ></div> -->
          </div>
          <!-- <div class="swiper-container gallery-thumbs">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in swiperList"
                :key="index"
              >
                <img :src="item.imgeUrl" alt="" />
                <p class="posBack">
                  {{ item.uptTime | moment("YYYY-MM-DD ") }}
                </p>
              </div>
            </div>
          </div> -->
        </div>
        <div class="video-info public-info" v-show="deviceTypeId == 40">
          <p class="video-info-tit public-info-tit">
            <span><strong class="line"></strong>视频监测</span
            ><img
              src="@/assets/agricultural/nqfont/screen_icon.png"
              alt=""
              class="screen_icon"
              @click="checkHistory(4)"
            />
          </p>
          <div class="videoContainer clearfix videoItems">
            <div class="videoParentStyle" @dblclick="isFullScreen">
              <div id="playVideo" style="width: 100%; height: 300px"></div>
              <div class="positionVideoBtn"></div>
            </div>
            <div class="videoBtnBox">
              <button class="iconfont buttonIcon" @click="ptzControl(0)">
                &#xe602;<span>上翻</span>
              </button>
              <button class="iconfont buttonIcon" @click="ptzControl(1)">
                &#xe603;<span>下翻</span>
              </button>
              <button class="iconfont buttonIcon" @click="ptzControl(2)">
                &#xe605;<span>左翻</span>
              </button>
              <button class="iconfont buttonIcon" @click="ptzControl(3)">
                &#xe604;<span>右翻</span>
              </button>
              <button class="iconfont buttonIcon" @click="ptzControl(11)">
                &#xe609;<span>焦距</span>
              </button>
              <button class="iconfont buttonIcon" @click="ptzControl(10)">
                &#xe608;<span>焦距</span>
              </button>
              <button class="iconfont buttonIcon" @click="ptzControl(8)">
                &#xe607;<span>放大</span>
              </button>
              <button class="iconfont buttonIcon" @click="ptzControl(9)">
                &#xe60a;<span>缩小</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var EZUIKit;
var ms_ie = false;
var ua = window.navigator.userAgent.toLowerCase();
// console.log(ua);
// alert(ua)
var old_ie = ua.indexOf("MSIE");
var new_ie = ua.indexOf("trident/");
var is360 = false;
var append = document.getElementById("append");
if (old_ie > -1 || new_ie > -1) {
  // alert(old_ie,new_ie)
  // alert(6)
  EZUIKit = false;
  ms_ie = true;
}
if (window.navigator.appName.indexOf("Microsoft") != -1) {
  //alert(5)
  me_ie = true;
}
// if (window.navigator.userAgent.indexOf("Chrome/63") != -1) {
//   EZUIKit = false;
// }
if (window.navigator.mimeTypes[40] || !window.navigator.mimeTypes.length) {
  // alert(4)
  EZUIKit = false;
  is360 = true;
}

if (ms_ie) {
  // alert(3)
  EZUIKit = false;
  var DEFAULT_VERSION = 8.0;
  var ua = navigator.userAgent.toLowerCase();
  var isIE = ua.indexOf("msie") > -1;
  var safariVersion;
  if (isIE) {
    // alert(2)
    safariVersion = ua.match(/msie ([d.]+)/)[1];
  }
  if (safariVersion <= DEFAULT_VERSION) {
    //alert(1)
    EZUIKit = false;
    console.log(
      "系统检测到您正在使用ie8以下内核的浏览器，不能实现完美体验，请更换或升级浏览器访问！"
    );
  }
}
if (EZUIKit != false) {
  EZUIKit = require("@/utils/ezuikit.js");
}

//import EZUIKit from "ezuikit-js";
import Swiper from "./js/swiper.min.js";
import "./css/swiper.css";

export default {
  data() {
    return {
      urls: [],
      srcImg: "",
      EZUIKit: EZUIKit,
      currentPage: 1,
      pageSize: 10,
      swiperList: [],
      soilData: {},
      EnvData: {},
      videoUrl: "",
      hkToken: "",
      decoderPath: "",
      deviceName: "",
      deviceTypeId: "",
      deviceCode: "",
      deviceName: "",
      deviceTypeName: "",
      showSwiper: false,
      deviceStatus: "设备加载中",
      yesDate: "",
      growSubmitObj: {},
      systemTime: "",
      nowTime: "",
      timer: null,
      deviceFlag: 2,
      srcList: [],
      edition: "",
      soilV4temData: "",
      soilV4humData: "",
      soilV4SaltData: "",
      soilV4ConData: "",
      envV4Temperature: "",
      envV4Humidity: "",
      envV4WindDirection: "",
      envV4WindSpeed: "",
      envV4Pressure: "",
      envV4Light: "",
    };
  },
  props: ["farmAllData"],
  watch: {
    farmAllData() {
      this.initDeviceMsg();
    },
  },
  mounted() {
    this.initDeviceMsg();
  },
  beforeDestroy() {
    if (this.player != null) {
      this.player.stop();
      this.player = null;
    }

    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    // 获取年月日
    convertToDate(date) {
      var date = new Date(date);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      m = m < 10 ? "0" + m : m;
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    },
    // 获取时分
    converTimeDate(date) {
      var date = new Date(date);
      var h = date.getHours();
      var s = date.getMinutes();
      h = h < 10 ? "0" + h : h;
      s = s < 10 ? "0" + s : s;
      return h + ":" + s;
    },
    initDeviceMsg() {
      console.log(this.farmAllData.deviceTypeId);
      this.deviceTypeId = this.farmAllData.deviceTypeId;
      this.deviceTypeName = this.farmAllData.deviceTypeName;
      this.deviceCode = this.farmAllData.deviceCode;
      this.deviceName = this.farmAllData.deviceName;
      this.edition = this.farmAllData.edition;
      if (this.deviceTypeId == 10) {
        this.EnvData = {
          temperature: "",
          humidity: "",
          windDirection: "",
          windSpeed: "",
          pressure: "",
          light: "",
        };
        this.getEnvData();
      } else if (this.deviceTypeId == 20) {
        this.getSoilData();
      } else if (this.deviceTypeId == 30) {
        // 默认进来剩余时间段调历史接口
        this.systemTime = this.convertToDate(new Date());
        let qDay = new Date(
          new Date(this.systemTime).getTime() - 24 * 60 * 60 * 1000
        ); //计算当前日期 -1
        this.yesDate = this.convertToDate(qDay);
        this.nowTime = this.converTimeDate(new Date());
        if (
          (this.nowTime >= "00:00" && this.nowTime <= "07:00") ||
          (this.nowTime >= "19:00" && this.nowTime <= "24:00")
        ) {
          this.deviceStatus = "夜间监测休眠";
        } else {
          this.getHisDevData();
        }

        // 添加定时器
        this.timer = setInterval(() => {
          // 获取当天日期
          this.systemTime = this.convertToDate(new Date());
          // 获取当天时分
          this.nowTime = this.converTimeDate(new Date());
          // 获取昨天日期
          let beforeDay = new Date(
            new Date(this.systemTime).getTime() - 24 * 60 * 60 * 1000
          ); //计算当前日期 -1
          this.yesDate = this.convertToDate(beforeDay); //格式化日期并赋值
          // 19:00-07:00 夜间监测休眠模式
          if (
            (this.nowTime >= "00:00" && this.nowTime <= "07:00") ||
            (this.nowTime >= "19:00" && this.nowTime <= "24:00")
          ) {
            this.deviceStatus = "夜间监测休眠";
          } else {
            if (this.deviceFlag == 1) {
              if (
                (this.nowTime >= "09:00" && this.nowTime <= "09:10") ||
                (this.nowTime >= "10:00" && this.nowTime <= "10:10") ||
                (this.nowTime >= "11:00" && this.nowTime <= "11:10") ||
                (this.nowTime >= "12:00" && this.nowTime <= "12:10") ||
                (this.nowTime >= "13:00" && this.nowTime <= "13:10") ||
                (this.nowTime >= "14:00" && this.nowTime <= "14:10") ||
                (this.nowTime >= "15:00" && this.nowTime <= "15:10") ||
                (this.nowTime >= "16:00" && this.nowTime <= "16:10")
              ) {
                this.deviceStatus = "长势正在拍照中";
              } else {
                this.deviceStatus = "设备正常";
              }
            } else if (this.deviceFlag == 0) {
              this.deviceStatus = "设备异常";
            }
          }
        }, 1000);
        // 调当天长势接口
        this.getPicLately();
        // this.getGrowData();
      } else if (this.deviceTypeId == 40) {
        document.getElementById("playVideo").innerHTML = "";
        if (this.EZUIKit) {
          this.getVideoUrl();
        }
        //  else {
        //   this.$message({
        //     message:
        //       "该浏览器对于视频监控不能实现完美体验，请更换或升级浏览器访问！",
        //     type: "error",
        //     customClass: "customClass",
        //   });
        // }
      }
      this.$nextTick(() => {
        if (this.player != null) {
          this.player.stop();
          this.player = null;
        }
      });
    },

    // 历史设备去状态接口
    getHisDevData() {
      var obj = {
        deviceCode: this.deviceCode,
        type: 3, //自定义时间段
        startTime: this.yesDate,
        endTime: this.systemTime,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      };
      this.$http.nqMonitor.monitorGrow(obj).then((res) => {
        if (res.data.content.length > 0) {
          this.deviceFlag = 1;
        } else {
          this.deviceFlag = 0;
        }
      });
    },
    // 土壤监测
    getSoilData() {
      if (this.edition != 4) {
        this.$http.nqMonitor
          .monitorSoil({ sensorNum: this.deviceCode })
          .then((res) => {
            console.log(res);
            if (res.status == 1) {
              this.soilData = res.data;

              this.deviceStatus = res.data.deviceState;
            } else {
              this.deviceStatus = null;
            }
          });
      } else {
        this.$http.nqMonitor
          .monitorGroupV4({ imei: this.deviceCode })
          .then((res) => {
            if (res.status == 1) {
              if (res.data.result && res.data.result.length > 0) {
                let soilV4DataList = res.data.result;
                var that = this;
                soilV4DataList.forEach((val) => {
                  // B1土壤温度
                  if (val.sensorType && val.sensorType == "B1") {
                    that.soilV4temData = val.sensorData;
                  }
                  // B2土壤湿度
                  if (val.sensorType && val.sensorType == "B2") {
                    that.soilV4humData = val.sensorData;
                  }
                  // B3土壤盐分
                  if (val.sensorType && val.sensorType == "B3") {
                    that.soilV4SaltData = val.sensorData;
                  }
                  // B4土壤电导率
                  if (val.sensorType && val.sensorType == "B4") {
                    that.soilV4ConData = val.sensorData;
                  }
                });

                let A = new Date(res.data.result[0].sendTime);
                let U = A.getTime();
                let V = new Date(new Date() - 1000 * 60 * 60 * 24 * 30); //三十天前的时间戳
                console.log(U);
                if (U < V) {
                  this.deviceStatus = "设备异常";
                } else {
                  this.deviceStatus = "设备正常";
                }
              } else {
                this.soilV4temData = "";
                this.soilV4humData = "";
                this.soilV4SaltData = "";
                this.soilV4ConData = "";
                this.deviceStatus = null;
              }
            } else {
              this.deviceStatus = null;
            }
          });
      }
    },
    // 环境实时
    getEnvData() {
      if (this.edition != 4) {
        this.$http.nqMonitor
          .monitorEnv({ sensorNum: this.deviceCode })
          .then((res) => {
            if (res.status == 1) {
              this.EnvData = {
                temperature: "",
                humidity: "",
                windDirection: "",
                windSpeed: "",
                pressure: "",
                light: "",
              };

              if (res.data && res.data != null) {
                var windDirection = "";
                if (res.data.windDirection && res.data.windDirection != null) {
                  if (res.data.windDirection == "W") {
                    windDirection = "西";
                  } else if (res.data.windDirection == "N") {
                    windDirection = "北";
                  } else if (res.data.windDirection == "E") {
                    windDirection = "东";
                  } else if (res.data.windDirection == "ES") {
                    windDirection = "东南";
                  } else if (res.data.windDirection == "WS") {
                    windDirection = "西南";
                  } else if (res.data.windDirection == "WN") {
                    windDirection = "西北";
                  } else if (res.data.windDirection == "S") {
                    windDirection = "南";
                  } else if (res.data.windDirection == "EN") {
                    windDirection = "东北";
                  }
                }
                this.EnvData = {
                  temperature:
                    res.data.temperature != null
                      ? res.data.temperature + "℃"
                      : "—",
                  humidity:
                    res.data.humidity != null ? res.data.humidity + "%" : "—",
                  pressure: res.data.humidity != null ? 0 + "kpa" : "—",
                  windDirection:
                    windDirection != "" ? windDirection + "风" : "—",
                  windSpeed:
                    res.data.windSpeed != null
                      ? res.data.windSpeed + "km/h"
                      : "—",
                  light: res.data.light != null ? res.data.light + "lux" : "—",
                };
                this.deviceStatus = res.data.deviceState;
              } else {
                this.deviceStatus = null;
              }
            } else {
              this.deviceStatus = null;
            }
          });
      } else {
        this.$http.nqMonitor
          .monitorGroupV4({ imei: this.deviceCode })
          .then((res) => {
            if (res.status == 1) {
              console.log(res.data.result);
              if (res.data.result && res.data.result.length > 0) {
                let envV4DataList = res.data.result;
                var that = this;
                envV4DataList.forEach((val) => {
                  // A0空气温度
                  if (val.sensorType && val.sensorType == "A0") {
                    that.envV4Temperature = val.sensorData;
                  }
                  // A1空气湿度
                  if (val.sensorType && val.sensorType == "A1") {
                    that.envV4Humidity = val.sensorData;
                  }
                  // A5大气压力
                  if (val.sensorType && val.sensorType == "A5") {
                    that.envV4Pressure = val.sensorData;
                  }
                  // A3风速
                  if (val.sensorType && val.sensorType == "A3") {
                    that.envV4WindSpeed = val.sensorData;
                  }
                  // A4风向
                  if (val.sensorType && val.sensorType == "A4") {
                    if (val.sensorData && val.sensorData != null) {
                      if (val.sensorData == "W") {
                        that.envV4WindDirection = "西";
                      } else if (val.sensorData == "N") {
                        that.envV4WindDirection = "北";
                      } else if (val.sensorData == "E") {
                        that.envV4WindDirection = "东";
                      } else if (val.sensorData == "ES") {
                        that.envV4WindDirection = "东南";
                      } else if (val.sensorData == "WS") {
                        that.envV4WindDirection = "西南";
                      } else if (val.sensorData == "WN") {
                        that.envV4WindDirection = "西北";
                      } else if (val.sensorData == "S") {
                        that.envV4WindDirection = "南";
                      } else if (val.sensorData == "EN") {
                        that.envV4WindDirection = "东北";
                      }
                    }
                  }
                  // A2光照强度
                  if (val.sensorType && val.sensorType == "A2") {
                    that.envV4Light = val.sensorData;
                  }
                });
                let A = new Date(res.data.result[0].sendTime);
                let U = A.getTime();
                let V = new Date(new Date() - 1000 * 60 * 60 * 24 * 30); //三十天前的时间戳
                console.log(U);
                if (U < V) {
                  this.deviceStatus = "设备异常";
                } else {
                  this.deviceStatus = "设备正常";
                }
              } else {
                this.envV4Temperature = "";
                this.envV4Humidity = "";
                this.envV4WindDirection = "";
                this.envV4WindSpeed = "";
                this.envV4Pressure = "";
                this.envV4Light = "";
                this.deviceStatus = null;
              }
            } else {
              this.deviceStatus = null;
            }
          });
      }
    },
    // 长势数据
    // getGrowData() {
    //   this.$http.nqMonitor
    //     .monitorGrow({
    //       deviceCode: this.deviceCode,
    //       type: 3, //自定义时间段
    //       startTime: this.systemTime,
    //       endTime: this.systemTime,
    //       currentPage: this.currentPage,
    //       pageSize: this.pageSize,
    //     })
    //     .then((res) => {
    //       if (res.data.content.length > 0) {
    //         this.showSwiper = true;
    //         this.swiperList = res.data.content;
    //         this.$nextTick(() => {
    //           this.swiperFun();
    //         });
    //       } else {
    //         this.showSwiper = false;
    //         this.swiperList = [];
    //       }
    //     });
    // },
    // 长势图片最近三张
    getPicLately() {
      let obj = {
        deviceCode: this.deviceCode,
        num: 3, //最近条数，默认3条
      };
      this.$http.nqMonitor.picLately(obj).then((res) => {
        // console.log(res);
        if (res.status === "1") {
          this.urls = res.data;
          this.srcList = [];
          this.showSwiper = true;
          this.urls.forEach((item, index) => {
            this.srcList.push(item.imgeUrl);
          });
        } else {
          this.showSwiper = false;
          this.srcList = [];
          this.$message({
            message: res.errMsg,
            type: "error",
            customClass: "customClass",
          });
        }
      });
    },
    // 长势
    swiperFun() {
      var that = this;
      var galleryThumbs = new Swiper(".gallery-thumbs", {
        spaceBetween: 8,
        slidesPerView: "auto",
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      });
      var galleryTop = new Swiper(".gallery-top", {
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          swiper: galleryThumbs,
        },
        on: {
          click: function () {
            if (this.clickedIndex != undefined) {
              that.srcImg = this.clickedSlide.firstChild.currentSrc;
            }
          },
        },
      });
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp * 1); //这个是10位数字的转换 如果想要13位数的话需要乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        date.getHours() < 10
          ? "0" + date.getHours() + ":"
          : date.getHours() + ":";
      var m =
        date.getMinutes() < 10
          ? "0" + date.getMinutes() + ":"
          : date.getMinutes() + ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    // 获取视频地址
    getVideoUrl() {
      let submitData = {
        deviceSerial: this.deviceCode,
        quality: 1,
      };
      this.$http.nqMonitor.videoPlayAddress(submitData).then((res) => {
        this.deviceStatus = "设备加载中";
        if (res.data.code == 200) {
          this.videoUrl = res.data.data.url;
          this.hkToken = res.data.hkystoken;
          this.deviceStatus = "设备正常";

          this.$nextTick(() => {
            this.playVideo();
          });
        } else if (res.data.code == 20014) {
          this.deviceStatus = "设备不存在";
          this.$message({
            message: "设备不存在",
            type: "error",
            customClass: "customClass",
          });
        } else if (res.data.code == 20007) {
          this.deviceStatus = "设备不在线";
          this.$message({
            message: "设备不在线",
            type: "error",
            customClass: "customClass",
          });
        } else if (res.data.code == 20018) {
          this.deviceStatus = "设备异常";
          this.$message({
            message: "设备异常，请联系管理员",
            type: "error",
            customClass: "customClass",
          });
        } else {
          this.deviceStatus = "设备不在线";
          this.$message({
            message: "设备不在线",
            type: "error",
            customClass: "customClass",
          });
        }
      });
    },
    playVideo() {
      this.player = new EZUIKit.EZUIKitPlayer({
        id: "playVideo",
        url: this.videoUrl,
        autoplay: true,
        accessToken: this.hkToken,
        decoderPath: this.decoderPath,
        width: 265,
        height: 150,
      });
    },

    isFullScreen() {
      this.player.fullScreen();
    },
    ptzControl(direction) {
      this.toControl(direction, 1);
    },
    //控制云台
    toControl(direction, speed) {
      var sta = false;
      if (-1 == direction) {
        this.isTurn = false;
        direction = 2;
        sta = true; //镜头一直转
      }
      if (direction == 111) {
        direction = 2;
        this.isTurn = true;
        this.closeControl();
      }
      let submitData = {
        deviceSerial: this.deviceCode,
        channelNo: 1,
        direction: direction,
        speed: speed,
      };
      this.$http.nqMonitor.videoControl(submitData).then((res) => {
        if (res.data.status == 1) {
          if (!sta) {
            this.closeControl();
          }
        }
      });
    },
    //停止云台控制
    closeControl() {
      let submitData = {
        deviceSerial: this.deviceCode,
        channelNo: 1,
      };
      this.$http.nqMonitor.stopControl(submitData).then((res) => {
        if (res.data.status == 1) {
        } else {
          this.$message({
            message: res.data.errMsg,
            type: "error",
            customClass: "customClass",
          });
        }
      });
    },
    // 查看历史数据
    checkHistory(val) {
      sessionStorage.setItem("deviceCode", this.deviceCode);
      sessionStorage.setItem("deviceName", this.deviceName);
      if (val == 1) {
        this.$router.push("/Agricultural/AgriculturalMonitoring/Soil");
      } else if (val == 2) {
        this.$router.push("/Agricultural/AgriculturalMonitoring/Weather");
      } else if (val == 3) {
        this.$router.push("/Agricultural/AgriculturalMonitoring/Vigour");
      } else if (val == 4) {
        if (this.player != null) {
          this.player.stop();
          this.player = null;
        }
        this.$emit("videoChange", true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .swiper-button-prev:after,
.swiper-rtl .swiper-button-next:after,
.swiper-button-next:after,
.swiper-rtl .swiper-button-prev:after {
  content: "" !important;
}

#playVideo {
  position: relative;
}

::v-deep #playVideo iframe {
  width: 100% !important;
}

.map-right-info {
  background: transparent !important;

  .map-right-info-content {
    height: 100%;
    padding: 15px;
    box-sizing: border-box;
    overflow-y: auto;

    /*滚动条样式*/
    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgba(255, 255, 255, 0.2);
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 0;
      background: rgba(255, 255, 255, 0.1);
    }
  }

  .map-device-detail {
    .device-info {
      color: #ffffff;
      padding-bottom: 15px;
      border-bottom: 1px solid #3d403b;

      p {
        line-height: 24px;

        .deviceName {
          color: #ff9600;
          font-size: 20px;
          line-height: 30px;
        }
      }

      .device-info-text {
        font-size: 16px;
        line-height: 24px;

        .equip-right-text {
          color: #3bc329;
        }

        .equip-error-text {
          color: #ff0000;
        }

        img {
          width: 18px;
          height: auto;
          margin-top: 4.2px;
          margin-right: 4px;
        }

        .yzd {
          cursor: pointer;
          float: right;
          margin-right: 10px;
          font-size: 13.5px;
        }
      }

      p:nth-child(1) {
        display: flex;
        justify-content: space-between;
        margin-bottom: 4px;
        font-size: 16px;
      }
    }

    .public-info {
      border-radius: 10px;
      padding: 20px 0 0 5px;

      .public-info-tit {
        display: flex;
        justify-content: space-between;
        margin-bottom: 14px;
        color: #ffffff;

        span:nth-child(1) {
          font-size: 18px;
          position: relative;
          padding-left: 5px;

          .line {
            width: 5px;
            height: 20px;
            background: #018388;
            border-radius: 3px;
            left: -5px;
            display: inline-block;
            position: absolute;
            top: 2px;
          }
        }

        span:nth-child(2) {
          cursor: pointer;
          background: rgba(1, 131, 136, 0.5);
          border-radius: 13px;
          font-size: 14px;
          padding: 3px 12px;
        }

        .screen_icon {
          width: 20px;
          height: 20px;
          margin-top: 3px;
          cursor: pointer;
          margin-right: 3px;
        }
      }

      ul {
        padding-right: 4px;
      }
    }

    .soil-info {
      ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }

      ul li {
        width: 49.6%;
        display: flex;
        align-items: center;
        line-height: 26px;
        border-bottom: 1px solid #3d403b;
        border-right: 1px solid #3d403d;
        padding: 12px 0 18px 0;

        img {
          width: auto;
          height: 36px;
          padding-right: 10px;
          margin-top: 3px;
        }

        p {
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          span:nth-child(1) {
            color: #2ac9cf;
          }

          span:nth-child(2) {
            color: #d0e7e8;
            line-height: 20px;
            font-size: 16px;
          }
        }
      }

      ul li:nth-child(even) {
        border-right: 0;

        img {
          padding-left: 14px;
        }
      }

      ul li:nth-child(3),
      ul li:nth-child(4) {
        border-bottom: 0;
      }
    }

    .env-info {
      ul {
        display: flex;
        flex-wrap: wrap;
        padding-top: 8px;

        li {
          width: 32.8%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          line-height: 30px;
          padding: 12px 0 18px 0;
          color: #ffffff;
          border-bottom: 1px solid #3d403b;
          border-right: 1px solid #3d403d;

          img {
            height: 37px;
          }

          span {
            color: #2ac9cf;
          }

          label {
            // height: 20px;
            font-size: 16px;
          }
        }

        li:nth-child(3),
        li:nth-child(6) {
          border-right: 0;
        }

        li:nth-child(4),
        li:nth-child(5),
        li:nth-child(6) {
          border-bottom: 0;
        }
      }
    }

    .grow-info {
      overflow: hidden;
      padding-left: 0 !important;

      .swiper-container {
        margin-left: auto;
        margin-right: auto;
        position: relative;
        overflow: hidden;
        list-style: none;
        padding: 0;
        z-index: 1;
      }

      .swiper-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;
        display: flex;
        transition-property: transform;
        -webkit-box-sizing: content-box;
        box-sizing: content-box;
      }

      .swiper-slide {
        flex-shrink: 0;
        width: 100%;
        height: 100%;
        position: relative;
        transition-property: transform;
        background-size: cover;
        background-position: 50%;
      }

      .gallery-top {
        height: 160px;
        width: 95%;
        margin-top: 20px;
      }

      .gallery-top .swiper-slide {
        width: 100%;
      }

      .gallery-top .swiper-slide img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .gallery-thumbs {
        height: 20%;
        width: 96%;
        box-sizing: border-box;
        padding: 10px 0 0 0;
      }

      .gallery-thumbs .swiper-slide {
        width: 31% !important;
        height: 64px !important;
        opacity: 0.7 !important;
        margin-right: 8px !important;
      }

      .gallery-thumbs .swiper-slide img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .gallery-thumbs .swiper-slide-thumb-active {
        border: 2px solid #2ac9cf;
        opacity: 1 !important;
        box-sizing: border-box;
      }

      .swiper-button-prev,
      .swiper-button-next {
        position: absolute;
        top: 55%;
        width: 27px;
        height: 44px;
        margin-top: -22px;
        z-index: 10;
        cursor: pointer;
        background-size: 27px 44px;
        background-position: center;
        background-repeat: no-repeat;
      }

      .swiper-button-next {
        right: 10px;
        left: auto;
        height: 22px !important;

        :root {
          background: transparent !important;
        }
      }

      .swiper-button-prev {
        left: 10px;
        right: auto;
        height: 22px !important;

        :root {
          background: transparent !important;
        }
      }

      .posBack {
        background: rgba(0, 0, 0, 0.3);
        color: #fff;
        text-align: center;
        font-size: 12px;
        height: 24px;
        line-height: 24px;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
      }
    }

    .video-info {
      .videoParentStyle {
        height: 180px;
        background: #cccccc;
        position: relative;
        overflow: hidden;
        margin: 10px 0;
      }

      .positionVideoBtn {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 30px;
        background: #666666;
        line-height: 30px;
      }

      .posterBtn,
      .videoBtn {
        color: #a9b597;
        border: none;
        font-size: 1.1vw !important;
        margin-left: 1vh;
      }

      .puseBtn {
        color: #fff;
        border: none;
        margin-left: 2vh;
      }

      .buttonIcon {
        color: #fff;
        padding: 0.5vw 0vw;
        border: none;
        background: #5c5c5c;
        margin-bottom: 1.2vh;
        width: 47%;
        margin-right: 3%;
      }

      .videoBtnBox {
        padding-left: 3%;
      }

      .videoBtnBox .buttonIcon:nth-child(even) {
        margin-right: 0;
      }

      .videoItems {
        margin-top: 20px;
        background: #333333;
      }

      .buttonIcon span {
        margin-left: 0.3vw;
      }
    }
  }

  .scroll-container {
    .imgItem {
      position: relative;

      p {
        position: absolute;
        bottom: 0;
        text-align: center;
        width: 100%;
        height: 26px;
        line-height: 26px;
        text-align: center;
        background: rgba(0, 0, 0, 0.6);
        color: #fff;
      }
    }
  }
}

::v-deep .el-image {
  width: 280px;
  height: 157.5px;
}
</style>
